export default __webpack_public_path__ + "static/media/litho-landing-page-img-02.3cdb7794.png";